{
	"title": "Vous devez vous connecter",
	"description": "Pour afficher cette page, il est nécessaire d’être connecté. Veuillez vous connecter. Ensuite, vous serez redirigé vers la page demandée.",
	"primaryButtonTitle": "Ouvrir la page de connexion"
}
